import React, { useState, useEffect } from "react";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import {
  getBusinessCategories,
  deleteBusinessCategory,
} from "../../../api/businessCategory";
import { usePagination } from "../../../hooks/usePagination";
import PaginationHandler from "../../../components/PaginationHandler";
import CustomTable from "../../../components/CustomTable/CustomTable";
import { Button, Input, Label } from "reactstrap";
import { t } from "i18next";
import { useNavigate } from "react-router-dom";

export default function BusinessCategoryList() {
  const navigate = useNavigate();

  const currentUser = JSON.parse(localStorage.getItem("currentUser")) || {};
  const role = currentUser.role || currentUser.roleName || {};

    const hasPermission = (action) => {
        if (role.name === "super admin") return true;
        return (
            role.permissions &&
            role.permissions.some(
                (perm) => perm.resource === "Monitor" && perm.actions.includes(action)
            )
        );
    };

    const canCreate = () => hasPermission("create");
    const canEdit = () => hasPermission("update");
    const canDelete = () => hasPermission("delete");
    const canRead = () => hasPermission("read");

  useEffect(() => {
    console.log("Current User:", currentUser);
    console.log("Role:", role.name);
    console.log("Permissions:", role.permissions);
  }, [currentUser]);

  const {
    response,
    loading,
    error,
    setPage,
    page,
    setMeta,
    totalPages,
  } = usePagination(getBusinessCategories, null, true);

  const [filters, setFilters] = useState({ name: "" });

  function handleFilter() {
    setMeta((m) => ({
      ...m,
      page: 1,
      payload: { ...filters },
    }));
  }

  const handleDelete = async (id) => {
    if (
      window.confirm("Are you sure you want to delete this business category?")
    ) {
      try {
        await deleteBusinessCategory(id);
        setPage(1);
      } catch (error) {
        console.error("Delete failed:", error);
        alert("Failed to delete business category.");
      }
    }
  };

  return (
    <div className="page-content">
      <div className="container-fluid">
        {/* Breadcrumb with Add Button */}
        <Breadcrumbs
          title={t("Business Categories")}
          addUrl={canCreate() ? "/business-categories/add" : null}
          hasAddBtn={canCreate()}
          isMainPage={true}
        />

        {/* Table */}
        {canRead() || canEdit() || canDelete() ? (
          response && response.length > 0 && !loading ? (
            <CustomTable
              emptyMsg={t("No Business Categories Found.")}
              data={response}
              loading={loading}
              error={error}
              cols={[
                {
                  label: t("Name"),
                  key: "name",
                  style: { width: "50%" },
                },
                {
                  label: t("Actions"),
                  key: "actions",
                  style: { width: "50%" },
                  renderer: (row) => (
                    <div className="d-flex gap-2">
                      {canEdit() && (
                        <Button
                          color="info"
                          size="sm"
                          onClick={() =>
                            navigate(`/business-categories/edit/${row._id}`)
                          }
                        >
                          {t("Edit")}
                        </Button>
                      )}
                      {canDelete() && (
                        <Button
                          color="danger"
                          size="sm"
                          onClick={() => handleDelete(row._id)}
                        >
                          {t("Delete")}
                        </Button>
                      )}
                    </div>
                  ),
                },
              ]}
            />
          ) : (
            !loading && <div>{t("No results found.")}</div>
          )
        ) : (
          <div>{t("You do not have permission to view this list.")}</div>
        )}

        {/* Pagination */}
        {response && !loading && canRead() && (
          <PaginationHandler
            page={page}
            setPage={setPage}
            totalPages={totalPages}
          />
        )}
      </div>
    </div>
  );
}
